import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';

import loadScript from 'chairisher/util/script';

import { getStripeJSUrl } from 'chairisher/context/script';
import { getPublishableStripeApiKey } from 'chairisher/context/payment';

function onError() {
    AlerterView.error(
        "Sorry! We're unable to contact Stripe. Some functionality on this page might be disabled. " +
            'Please try again later.',
    );

    // disable stripe related forms
    const $forms = $('.js-payment-method-stripe');
    $forms.find('input,select,textarea').prop('disabled', true);
    $forms.find('.btn, .js-saved-card-input').remove();

    // remove any links to remove stripe cards
    $('.js-stripe-card-remove').remove();
}

let stripePromise;

/**
 * @returns {Promise}
 */
function stripeLoader() {
    if (stripePromise) {
        return stripePromise;
    }
    stripePromise = loadScript({
        globalArg: getPublishableStripeApiKey(),
        rejectCallback: onError,
        scriptName: 'Stripe',
        scriptSrc: getStripeJSUrl(),
    });

    return stripePromise;
}

export default stripeLoader;
